import React from 'react';
import PropTypes from 'prop-types';

export default function Check({ fill = '#146FB4' }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 15 15"
		>
			<path
				fill={fill}
				d="M4.5 11 12.3.6a1.5 1.5 0 1 1 2.4 1.8l-9 12c-.6.8-1.8.8-2.4 0l-3-4a1.5 1.5 0 1 1 2.4-1.8L4.5 11Z"
			/>
		</svg>
	);
}

Check.propTypes = {
	fill: PropTypes.string,
};
